import React from "react";
import { Link } from "react-router-dom";
import { OrganizationState } from "go-security/services/organizations/types";
import { ReactComponent as GastroSupplierSVG } from "../../../../../../../images/svg/apps/large/gastrosupplier.svg";
import { ReactComponent as GoPosSVG } from "../../../../../../../images/svg/apps/large/gopos.svg";
import { ReactComponent as GoStockSVG } from "../../../../../../../images/svg/apps/large/gostock.svg";
import { AppProvider, OrderSourceApi } from "../../../../../../../services/Api/Organization/types";

interface Props {
	source: OrderSourceApi;
	organization: OrganizationState;
}

const getOrderSourceLogo = (appProvider: AppProvider) => {
	if (appProvider === "GOPOS" || appProvider === "GOPOS_V2") {
		return <GoPosSVG />;
	}
	if (appProvider === "LOCATIONS" || appProvider === "DOCUMENT_FILE_IMPORT" || appProvider === "DOCUMENT_TRANSFER") {
		return <GoStockSVG />;
	}
	if (appProvider === "GASTROSUPPLIER" || appProvider === "GASTROSUPPLIER_MERCHANT") {
		return <GastroSupplierSVG />;
	}
	return <></>;
};

const OrderSource = ({ source, organization }: Props) => {
	return (
		<div className="order-source d-flex align-items-center text-truncate">
			<Link className="logo" to={`/${organization.id}/apps/active/${source.app_id}`}>
				{getOrderSourceLogo(source.app_provider)}
			</Link>
			<div className="d-flex flex-column text-truncate ms-1">
				<Link
					to={`/${organization.id}/apps/active/${source.app_id}`}
					className="text-truncate app-name"
					title={source.app_name}
				>
					{source.app_name}
				</Link>
				{source?.link ? (
					<a
						href={`${source.link}`}
						target="_blank"
						rel="noreferrer"
						className="text-truncate"
						title={source.link}
					>
						#{source.number}
					</a>
				) : (
					<span title={source.number} className="text-truncate">
						#{source.number}
					</span>
				)}
			</div>
		</div>
	);
};

export default OrderSource;
